export default __webpack_public_path__ + "static/media/kashmir4.dadb8a56.jpg";